import { ArrowTopRightOnSquareIcon } from "@heroicons/react/16/solid";
import { useMemo } from "react";
import { generatePath, NavLink } from "react-router-dom";

import AddressDisplay from "~/components/address/AddressDisplay.tsx";
import CardValue from "~/components/Card/components/CardValue.tsx";
import { CLIENT_CONTACT_PATH } from "~/constants/appRoutes.ts";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import { useAllClients } from "~/modules/client/api/client/clientQueries.ts";
import type { ClientContactPersonType } from "~/modules/client/api/clientContactPerson/clientContactPersonTypes.ts";

type Props = {
	className?: string
	clientContactPerson: ClientContactPersonType;
	isSelfBilledInvoice: boolean;
};

const BillingSettingsContactPersonDisplay = ({ clientContactPerson, isSelfBilledInvoice }: Props) => {
	const {
		data: clientsData,
	} = useAllClients();

	const clientData = useMemo(() => {
		if (clientsData) {
			return clientsData.find(c => c.id === clientContactPerson.clientId);
		}

		return undefined;
	}, [clientContactPerson.clientId, clientsData]);

	const contactDetailsContent = <>
		<CardValue label="Name Kontaktperson">
			<NavLink className="flex items-center gap-x-1 hover:text-secondary-500"
					 to={generatePath(CLIENT_CONTACT_PATH, { contactId: clientContactPerson.id })}>
				{clientContactPerson.fullName}
				<ArrowTopRightOnSquareIcon className="ml-1 size-4" />
			</NavLink>
		</CardValue>
		<CardValue label="E-Mail"
				   enableCopyToClipboard={!!clientContactPerson.emailBusiness}>
			{clientContactPerson.emailBusiness || EMPTY_VALUE_PLACEHOLDER}
		</CardValue>
		<CardValue label="Telefon"
				   enableCopyToClipboard={!!(clientContactPerson.mobilePhone || clientContactPerson.phone)}>
			{clientContactPerson.mobilePhone || clientContactPerson.phone || EMPTY_VALUE_PLACEHOLDER}
		</CardValue>
	</>;

	if (isSelfBilledInvoice) {
		return <div className="grid grid-cols-2 gap-x-6 gap-y-4">
			{contactDetailsContent}
		</div>;
	}

	return <div className="grid grid-cols-2">
		<div className="space-y-4">
			{contactDetailsContent}
		</div>
		<div>
			<CardValue label="Rechnungsaddresse"
					   enableCopyToClipboard>
				{clientData && <AddressDisplay city={clientData.city}
											   countryId={clientData.countryId}
											   houseNumber={clientData.houseNumber}
											   street={clientData.street}
											   zipCode={clientData.zipCode}
				/>}
			</CardValue>
		</div>
	</div>;
};

export default BillingSettingsContactPersonDisplay;